import { useState, useEffect } from 'react'
import { apiService } from '../services/api'

export const useFinancialChargeOptions = () => {
 const [options, setOptions] = useState({
 types: [] as Array<{ value: string; label: string }>
 })
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)

 const fetchOptions = async () => {
 try {
 setIsLoading(true)
 setError(null)
 const response = await apiService.getFinancialChargeOptions()
 
 if (response) {
 setOptions({
 types: response.types || []
 })
 }
 } catch (err) {
 console.error('Erro ao carregar opções de encargos:', err)
 setError('Erro ao carregar opções. Tente novamente.')
 // Fallback para opções padrão
 setOptions({
 types: [
 { value: 'transfer', label: 'Transferência' },
 { value: 'tax', label: 'Impostos' },
 { value: 'fee', label: 'Taxas' },
 { value: 'warranty', label: 'Garantia' },
 { value: 'insurance', label: 'Seguro' },
 { value: 'ipva', label: 'IPVA' },
 { value: 'licensing', label: 'Licenciamento' },
 { value: 'documentation', label: 'Documentação' },
 { value: 'inspection', label: 'Vistoria' },
 { value: 'maintenance', label: 'Revisão/Manutenção' },
 { value: 'accessories', label: 'Acessórios' },
 { value: 'financing', label: 'Financiamento' },
 { value: 'transfer_fee', label: 'Taxa de Transferência' },
 { value: 'other', label: 'Outros' }
 ]
 })
 } finally {
 setIsLoading(false)
 }
 }

 useEffect(() => {
 fetchOptions()
 }, [])

 return {
 options,
 isLoading,
 error,
 fetchOptions
 }
}
